import Threads from "./dist/index.js"

export const registerSerializer = Threads.registerSerializer
export const spawn = Threads.spawn
export const BlobWorker = Threads.BlobWorker
export const DefaultSerializer = Threads.DefaultSerializer
export const Pool = Threads.Pool
export const Thread = Threads.Thread
export const Transfer = Threads.Transfer
export const Worker = Threads.Worker
